/* @flow */

import React, { Component } from 'react';
import reactStringReplace from 'react-string-replace';
import type { $StoreState } from '../../types/StoreState';
import Keys from '../../constants/WidgetFieldsKeys';
import { connect } from 'react-redux';
import { findDealers } from '../../store/search';
import { getWidgetFieldValueByKey } from 'CoreUtils/WidgetFieldUtils';
import renderTemplate from 'CoreUtils/TemplateRenderer';

type $ComponentProps = {
  resultsCount: number,
  currentResultsView: string,
  toggleFilterCallback: Function
};

type $MappedProps = {
  searchTerm: string,
  suggestedSearch: ?string,
  resultsCountParagraphTemplate: string,
  resultsCountSingularParagraphTemplate: string,
  resultsCountSuggestionParagraphTemplate: string,
  searchInsteadLinkParagraphTemplate: string,
  hideFilter: boolean,
  findDealers: Function
};

type $Props = $ComponentProps & $MappedProps;

class SearchResultsSummary extends Component<$Props> {

  handleSearchInsteadLinkClick = (event: SyntheticInputEvent<HTMLInputElement>) => {
    event.preventDefault();
    this.props.findDealers({
      isSearchByLocationActive: true,
      searchLocationString: this.props.searchTerm,
      searchNameString: null,
      spellCheck: false
    });
  };

  render() {
    const {
      searchTerm,
      resultsCount,
      resultsCountParagraphTemplate,
      resultsCountSingularParagraphTemplate,
      resultsCountSuggestionParagraphTemplate,
      searchInsteadLinkParagraphTemplate,
      suggestedSearch
    } = this.props;

    const suggestionEnabled = suggestedSearch && suggestedSearch !== searchTerm;

    if (suggestionEnabled) {
      const resultsCountPgph = resultsCountSuggestionParagraphTemplate &&
        renderTemplate(resultsCountSuggestionParagraphTemplate, { numResults: resultsCount, suggestedSearch });
      const searchInsteadLinkPgph = searchInsteadLinkParagraphTemplate &&
        renderTemplate(searchInsteadLinkParagraphTemplate, { originalSearch: searchTerm });

      return (
        <div className="dsw-search-results-summary dsw-search-results-summary-suggested">
          <p className="dsw-search-results-summary__count--pgph">
            { reactStringReplace(resultsCountPgph, suggestedSearch, (idx) => (
              <span key={idx} className="dsw-search-results-summary__suggestion">{suggestedSearch}</span>
            ))}
          </p>
          <a href="#" className="dsw-search-results-summary__alt" onClick={this.handleSearchInsteadLinkClick}>
            { reactStringReplace(searchInsteadLinkPgph, searchTerm, (idx) => (
              <span key={idx} className="dsw-search-results-summary__original">{searchTerm}</span>
            ))}
          </a>
        </div>
      );
    }
    else {
      const shouldUseSingularResultText = (resultsCount && resultsCount === 1)
        && !!resultsCountSingularParagraphTemplate;
      const template = shouldUseSingularResultText
        ? resultsCountSingularParagraphTemplate
        : resultsCountParagraphTemplate;
      const resultsCountPgph = template && renderTemplate(template, { numResults: resultsCount });

      return (
        <div className="dsw-search-results-summary">
          <p className="dsw-search-results-summary__count--pgph">{resultsCountPgph}</p>
        </div>
      );
    }
  }
}

const mapStateToProps = (state: $StoreState) => ({
  searchTerm: state.dsw.search.searchTerm,
  suggestedSearch: state.dsw.search.suggestedSearch,
  resultsCountParagraphTemplate: getWidgetFieldValueByKey(Keys.PARAGRAPH_RESULTS_COUNT, state.dsw),
  resultsCountSingularParagraphTemplate: getWidgetFieldValueByKey(Keys.PARAGRAPH_RESULTS_COUNT_SINGULAR, state.dsw),
  resultsCountSuggestionParagraphTemplate: getWidgetFieldValueByKey(Keys.PARAGRAPH_RESULTS_SUGGESTED_COUNT, state.dsw),
  searchInsteadLinkParagraphTemplate: getWidgetFieldValueByKey(Keys.PARAGRAPH_SEARCH_INSTEAD_LINK, state.dsw),
  hideFilter: getWidgetFieldValueByKey(Keys.DROPDOWN_FILTER_HIDE, state.dsw)
});

const mapDispatchToProps: Object = {
  findDealers
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsSummary);
